// extracted by mini-css-extract-plugin
export default {"aboutTitle":"ProductAbout_aboutTitle__oQL7F","aboutDescription":"ProductAbout_aboutDescription__jgK+O"};